module.exports = __webpack_public_path__ + "img/60600.3072d6bb.jpg";